import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getOrNull1d60i0672n7ns as getOrNull,
  indexOf3ic8eacwbbrog as indexOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from './PluginGeneratedSerialDescriptor.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from '../descriptors/SerialDescriptors.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { getChecked1o70dkx10jwym as getChecked } from './Platform.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_elementNamesl5b6t976dltd as get_elementNames,
} from '../descriptors/SerialDescriptor.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { contentToString3ujacv8hqfipd as contentToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
  var descriptor = new (EnumDescriptor())(serialName, values.length);
  if (classAnnotations == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = classAnnotations.length;
    while (inductionVariable < last) {
      var element = classAnnotations[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      descriptor.j1y(element);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var inductionVariable_0 = 0;
  var last_0 = values.length;
  while (inductionVariable_0 < last_0) {
    var item = values[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0_elvis_lhs = getOrNull(names, _unary__edvuaz);
    var elementName = tmp0_elvis_lhs == null ? item.v1_1 : tmp0_elvis_lhs;
    descriptor.k1y(elementName);
    var tmp1_safe_receiver = getOrNull(entryAnnotations, _unary__edvuaz);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        descriptor.l1y(element_0);
      }
    }
  }
  return EnumSerializer().p1y(serialName, values, descriptor);
}
function createSimpleEnumSerializer(serialName, values) {
  return EnumSerializer().q1y(serialName, values);
}
function _get_elementDescriptors__y23q9p($this) {
  var tmp0 = $this.e1z_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
  return tmp0.n3();
}
function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
  return constructCallableReference((p0) => _get_elementDescriptors__y23q9p(p0), 1, 0, 10);
}
var EnumDescriptorClass;
function EnumDescriptor() {
  if (EnumDescriptorClass === VOID) {
    class $ extends PluginGeneratedSerialDescriptor() {
      constructor(name, elementsCount) {
        super(name, VOID, elementsCount);
        this.d1z_1 = ENUM_getInstance();
        var tmp = this;
        tmp.e1z_1 = lazy(() => {
          var tmp = 0;
          var tmp_0 = elementsCount;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_1 = Array(tmp_0);
          while (tmp < tmp_0) {
            var tmp_2 = tmp;
            tmp_1[tmp_2] = buildSerialDescriptor(name + '.' + this.b1q(tmp_2), OBJECT_getInstance(), []);
            tmp = tmp + 1 | 0;
          }
          return tmp_1;
        });
      }
      x1p() {
        return this.d1z_1;
      }
      e1q(index) {
        return getChecked(_get_elementDescriptors__y23q9p(this), index);
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null)
          return false;
        if (!isInterface(other, SerialDescriptor()))
          return false;
        if (!(other.x1p() === ENUM_getInstance()))
          return false;
        if (!(this.e1o() === other.e1o()))
          return false;
        if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
          return false;
        return true;
      }
      toString() {
        return joinToString(get_elementNames(this), ', ', this.e1o() + '(', ')');
      }
      hashCode() {
        var result = getStringHashCode(this.e1o());
        // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
        // Inline function 'kotlin.collections.fold' call
        var accumulator = 1;
        var _iterator__ex2g4s = get_elementNames(this).p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var hash = accumulator;
          var tmp = imul(31, hash);
          // Inline function 'kotlin.hashCode' call
          var tmp1_elvis_lhs = element == null ? null : hashCode(element);
          accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        var elementsHashCode = accumulator;
        result = imul(31, result) + elementsHashCode | 0;
        return result;
      }
    }
    initMetadataForClass($, 'EnumDescriptor');
    EnumDescriptorClass = $;
  }
  return EnumDescriptorClass;
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new (EnumDescriptor())(serialName, $this.m1y_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.m1y_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    d.k1y(element.v1_1);
  }
  return d;
}
function EnumSerializer$_get_descriptor_$ref_j67dlw() {
  return constructCallableReference((p0) => p0.b1n(), 1, 0, 11);
}
var EnumSerializerClass;
function EnumSerializer() {
  if (EnumSerializerClass === VOID) {
    class $ {
      constructor(serialName, values) {
        return new.target.q1y(serialName, values);
      }
      static q1y(serialName, values) {
        var $this = createThis(this);
        $this.m1y_1 = values;
        $this.n1y_1 = null;
        var tmp = $this;
        tmp.o1y_1 = lazy(() => {
          var tmp0_elvis_lhs = $this.n1y_1;
          return tmp0_elvis_lhs == null ? createUnmarkedDescriptor($this, serialName) : tmp0_elvis_lhs;
        });
        return $this;
      }
      static p1y(serialName, values, descriptor) {
        var $this = this.q1y(serialName, values);
        $this.n1y_1 = descriptor;
        return $this;
      }
      b1n() {
        var tmp0 = this.o1y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
        return tmp0.n3();
      }
      h1z(encoder, value) {
        var index = indexOf(this.m1y_1, value);
        if (index === -1) {
          throw SerializationException().w1o(toString(value) + ' is not a valid enum ' + this.b1n().e1o() + ', ' + ('must be one of ' + contentToString(this.m1y_1)));
        }
        encoder.y1s(this.b1n(), index);
      }
      c1n(encoder, value) {
        return this.h1z(encoder, value instanceof Enum() ? value : THROW_CCE());
      }
      d1n(decoder) {
        var index = decoder.o1r(this.b1n());
        if (!(0 <= index ? index <= (this.m1y_1.length - 1 | 0) : false)) {
          throw SerializationException().w1o('' + index + ' is not among valid ' + this.b1n().e1o() + ' enum values, ' + ('values size is ' + this.m1y_1.length));
        }
        return this.m1y_1[index];
      }
      toString() {
        return 'kotlinx.serialization.internal.EnumSerializer<' + this.b1n().e1o() + '>';
      }
    }
    initMetadataForClass($, 'EnumSerializer', VOID, VOID, [KSerializer()]);
    EnumSerializerClass = $;
  }
  return EnumSerializerClass;
}
//region block: exports
export {
  createAnnotatedEnumSerializer as createAnnotatedEnumSerializer20ay4pme9p2h9,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
};
//endregion

//# sourceMappingURL=Enums.mjs.map
